module.exports = __webpack_public_path__ + "static/media/headerImage.7c198fe6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Teams/img/headerImage.jpg
// module id = 82
// module chunks = 0